<template>
    <div>
        <div>
            <section>
                <div v-if="$route.path == '/StockOut/StockOutHX'">
                    <el-form :inline="true" class="toolbar">
                        <el-form-item label="销售下单号:" label-width="90px">
                            <el-input v-model="query.OrderCode" class="formlength"></el-input>
                        </el-form-item>
                        <el-form-item label="出库单号:" label-width="80px">
                            <el-input v-model="query.OutCode" class="formlength"></el-input>
                        </el-form-item>
                        <el-form-item label="代理商:" label-width="76px">
                            <el-input v-model="query.AgentName" class="formlength"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人:" label-width="80px">
                            <el-input v-model="query.c_name" class="formlength"></el-input>
                        </el-form-item>
                        <!--<el-form-item label="所属区域:" label-width="80px">
                            <el-input v-model="query.AreaName" class="formlength"></el-input>
                        </el-form-item>-->
                        <el-form-item label="物流单号:" label-width="80px">
                            <el-input v-model="query.LogCode"></el-input>
                        </el-form-item>

                        <el-form-item label="出库单状态:" label-width="100px" v-if="false">
                            <el-select placeholder="-请选择-" class="formlength" v-model="query.Status">
                                <el-option v-for="option in queryType" :value="option.TypeValue" :label="option.TypeName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收货状态:" label-width="90px">
                            <el-select placeholder="-请选择-" class="formlength" v-model="query.ReceivingStatus">
                                <el-option v-for="option in queryDelivery" :value="option.TypeValue" :label="option.TypeName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-button type="primary" @click="onQuerySubmit" icon="search">查询</el-button>
                        <el-button type="primary" @click="onQueryClean" icon="delete2">重置</el-button>
                    </el-form>
                    <div>
                        <el-table :data="lists" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" @selection-change="selsChange" router>
                            <el-table-column width="200" label="出库单号" prop="StockOutCode"></el-table-column>
                            <el-table-column width="200" label="代理商" prop="AgentName"></el-table-column>
                            <el-table-column label="主联系人" prop="C_Name"></el-table-column>
                            <el-table-column width="200" label="销售下单号" prop="OrderCode"></el-table-column>
                            <el-table-column width="200" label="所属区域" prop="AreaName"></el-table-column>
                            <el-table-column width="200" label="出库单下单时间" prop="StockOutTime"></el-table-column>
                            <el-table-column width="200" label="业务员" prop="SaleEmployeeName"></el-table-column>
                            <el-table-column width="200" label="实际签收时间" prop="SignTime"></el-table-column>
                            <el-table-column width="200" label="物流单号" prop="LogisticsCode"></el-table-column>
                            <!--<el-table-column width="200" label="出库单状态" prop="StatusName"></el-table-column>-->
                            <el-table-column width="100" label="收货状态" prop="ReceivingStatusName"></el-table-column>
                            <el-table-column label="操作" width="200px" fixed="right">
                                <template scope="scope">
                                    <el-button size="small" @click="handleView(scope.$index, scope.row)" icon="view" type="success">查看</el-button>
                                    <el-button size="small" icon="edit" @click="EditHandle(scope.$index, scope.row)" :disabled="(scope.row.btnVue&4)<=0" type="primary">修改</el-button>
                                    <!--<el-button size="small" icon="delete" @click="handleDel(scope.$index, scope.row)" :disabled="(scope.row.btnVue&8)<=0" type="danger">删除</el-button>
                									<el-button size="small" icon="circle-cross" @click="EnableHandle(scope.$index, scope.row)" :disabled="(scope.row.btnVue&16)<=0" type="warning">作废</el-button>-->
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-col :span="24" class='btm-action'>
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
                        </el-pagination>
                    </el-col>
                </div>
                <div v-else>
                    <router-view></router-view>
                </div>
            </section>

            <!--查看-->
            <el-dialog title="销售下单审核" v-model="SaleCheckView" size="tiny">
                <el-form style="margin:20px;width:60%;min-width:100%" label-width="100px">

                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="SaleCheckView=false">通 过</el-button>
                    <el-button type="primary" @click="SaleCheckView=false">驳 回</el-button>
                    <el-button @click="SaleCheckView=false">取 消</el-button>

                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
/**
 * Created by administrator on 2017/3/31.
 */
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";
import $http from "$http";
import {
  GetThirdStockOutByPage,
  ERP_StockOutDel,
  ERP_InvalidStockOut
} from "@api/stockOutApi";
import NProgress from "nprogress";
export default {
  data: function() {
    return {
      Session: util.getSessin(),
      queryType: [
        { TypeName: "-请选择-", TypeValue: "-1" },
        { TypeName: "正常", TypeValue: "1" },
        { TypeName: "已作废", TypeValue: "3" }
      ],
      queryDelivery: [
        { TypeName: "-请选择-", TypeValue: "-1" },
        { TypeName: "待收货", TypeValue: "1" },
        { TypeName: "已收货(正常)", TypeValue: "2" },
        { TypeName: "已收货(异常)", TypeValue: "3" },
        { TypeName: "已反馈(正常)", TypeValue: "4" },
        { TypeName: "已反馈(异常)", TypeValue: "5" }
      ],
      loading2: false,
      lists: [{ Id: "346567788" }],
      pageIndex: 1,
      pageSize: 10,
      totalSize: "",
      sels: [], //列表选中列
      SaleCheckView: false,
      pageSizes: [10, 20, 50],
      query: this.getQueryData()
    };
  },
  methods: {
    getQueryData() {
      return cloneDeep({
        OutCode: "",
        OrderCode: "",
        SendCode: "",
        AgentName: "",
        AreaName: "",
        LogCode: "",
        Status: "",
        ReceivingStatus: "",
        BusUser: ""
      });
    },
    EditHandle(index, row) {
      util.redirect(
        this,
        "/StockOut/AddStockOutHX?StockOutId=" + row.StockOutId,
        false
      );
    },
    //初始化加载页面
    List: function() {
      this.lists = [];
      this.loading2 = true; //拼命加载中显示
      var para = this.getParams();
      GetThirdStockOutByPage(para).then(res => {
        util.doResult(this, res, () => {});
        let { StateCode, StateMsg, Data, Cnt } = res.data;
        for (var i = 0; i < Data.length; i++) {
          Data[i].AreaName = Data[i].AreaName.split("市")[0] + "市";
          if (Data[i].AreaName == "北京北京市") {
            Data[i].AreaName = "北京市";
          }
          if (Data[i].AreaName == "重庆重庆市") {
            Data[i].AreaName = "重庆市";
          }
          if (Data[i].AreaName == "上海上海市") {
            Data[i].AreaName = "上海市";
          }
          if (Data[i].AreaName == "天津天津市") {
            Data[i].AreaName = "天津市";
          }
        }
        this.outTips(StateCode, StateMsg, Data, Cnt);
      });
    },
    //通用输入参数
    getParams: function() {
      var para = {
        Sid: this.Session[0],
        Session: this.Session[1],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderBy: this.orderBy
      };
      for (let item in this.query) {
        let value = this.query[item];
        if (value != "") {
          para[item] = value;
        }
      }
      return para;
    },
    //通用提示信息
    outTips: function(StateCode, StateMsg, Data, Cnt) {
      if (StateCode !== 0 && StateCode !== 99) {
        this.$notify({
          title: "错误",
          message: StateMsg,
          type: "error"
        });
      } else {
        this.totalSize = Cnt;
        this.loading2 = false; //拼命加载中隐藏
        this.lists = Data;
      }
    },

    selsChange: function(sels) {
      this.sels = sels;
    },
    //查询
    onQuerySubmit: function() {
      this.pageIndex = 1;
      this.lists = [];
      this.loading2 = true; //拼命加载中显示
      var para = this.getParams();
      GetThirdStockOutByPage(para).then(res => {
        util.doResult(this, res, () => {});
        let { StateCode, StateMsg, Data, Cnt } = res.data;
        this.outTips(StateCode, StateMsg, Data, Cnt);
      });
    }, //查询功能
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.List();
    },
    //查询单条
    handleView: function(index, row) {
      util.redirect(
        this,
        "/StockOut/StockOutHXView?Id=" + row.StockOutId,
        true
      );
    }, //编辑功能
    onQueryClean: function() {
      this.query = this.getQueryData();
      this.List();
    },
    //删除
    handleDel: function(index, row) {
      this.$confirm("确认删除该记录吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          NProgress.start();
          let para = { Ids: row.StockOutId };
          ERP_StockOutDel(para).then(response => {
            NProgress.done();
            if (response.data.StateCode !== 0) {
              this.$notify({
                title: "错误",
                message: response.data.StateMsg,
                type: "error"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "删除成功",
                type: "success"
              });
              this.List();
            }
          });
        })
        .catch(() => {});
    },
    //作废
    EnableHandle: function(index, row) {
      this.$confirm("确认作废该记录吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          NProgress.start();
          let para = {
            Id: row.StockOutId,
            Sid: this.Session[0],
            Session: this.Session[1]
          };
          ERP_InvalidStockOut(para).then(response => {
            NProgress.done();
            if (response.data.StateCode !== 0) {
              this.$notify({
                title: "错误",
                message: response.data.StateMsg,
                type: "error"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "作废成功",
                type: "success"
              });
              this.List();
            }
          });
        })
        .catch(() => {});
    },

    handleCurrentChange: function(val) {
      this.pageIndex = val;
      this.List();
    }
  },

  created: function() {
    this.List();
  }
};
</script>

<style scoped lang="scss">
.btm-action {
  display: flex;
  justify-content: center;
  margin: 5px 0px;
}

.formlength {
  width: 160px;
}
</style>


// WEBPACK FOOTER //
// StockOutHX.vue?89436adc